import React, { useState, useEffect } from 'react';
import '../../styles/onboarding.css';

const steps = [
  {
    title: 'Find a Tutor',
    description: 'Search tutors by subject, level, availability and price. Use filters to narrow results. Note: you must be logged in to view full tutor profiles and book sessions.'
  },
  {
    title: 'Book a Session',
    description: 'Pick a convenient slot, confirm the booking and pay securely.'
  },
  {
    title: 'Learn & Review',
    description: 'Attend your session, leave a review and track progress in your dashboard.'
  }
];

const Onboarding = ({ onFinish }) => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    try {
      const seen = localStorage.getItem('seenOnboarding');
      if (!seen) setOpen(true);
    } catch (e) {
      setOpen(true);
    }
  }, []);

  const close = (markSeen = false) => {
    if (markSeen) localStorage.setItem('seenOnboarding', '1');
    setOpen(false);
    if (onFinish) onFinish();
  };

  if (!open) return null;

  const step = steps[index];

  return (
    <div className="onboarding-backdrop" role="dialog" aria-modal="true">
      <div className="onboarding-modal">
        <button className="onboarding-close" onClick={() => close()}>✕</button>
        <div className="onboarding-content">
          <h3 className="onboarding-title">{step.title}</h3>
          <p className="onboarding-desc">{step.description}</p>

          <div className="onboarding-footer">
            <div className="onboarding-progress">
              {steps.map((_, i) => (
                <span key={i} className={`dot ${i === index ? 'active' : ''}`}></span>
              ))}
            </div>

            <div className="onboarding-actions">
              {index > 0 ? (
                <button className="btn btn-outline" onClick={() => setIndex(index - 1)}>Back</button>
              ) : (
                <button className="btn btn-ghost" onClick={() => { close(true); }}>Skip</button>
              )}

              {index < steps.length - 1 ? (
                <button className="btn btn-primary" onClick={() => setIndex(index + 1)}>Next</button>
              ) : (
                <button className="btn btn-success" onClick={() => close(true)}>Finish</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
